/* eslint react/no-danger: 0 */
import React from 'react';
import DOMPurify from 'dompurify';

import { makeStyles } from '@material-ui/core/styles';
import Box from '@material-ui/core/Box';
import Typography from '@material-ui/core/Typography';
import Hidden from '@material-ui/core/Hidden';

const useStyles = makeStyles((theme) => ({
  productSalePrice: {
    fontWeight: 'bold',
    color: theme.palette.error.dark,
  },
  productSlogan: {
    fontSize: '1rem',
    fontWeight: 'bold',
  },
  productName: {
    fontSize: '1.2rem',
    fontWeight: 'bold',
  },
  productSpec: {
    color: 'rgb(170, 170, 170)',
    fontSize: '0.8rem',
    fontWeight: 'bold',
  },
}));

const Introduction = ({
  data = {},
}) => {
  const classes = useStyles();

  return (
    <>
      <Hidden only="sm">
        <Box mb={4}>
          <Typography className={classes.productSlogan}>{data.slogan}</Typography>
          <Typography className={classes.productName}>{data.title}</Typography>
          <Typography className={classes.productSpec}>{data.spec}</Typography>
        </Box>
      </Hidden>
      <Box mt={4} mb={4}>
        <pre dangerouslySetInnerHTML={{ __html: DOMPurify.sanitize(data.introduction, { ADD_ATTR: ['target'] }) }} />
      </Box>
    </>
  );
};

export default Introduction;
